import { Heart, X } from 'lucide-react';
import { cldImg } from '../../utils/cloudinary';

export default function RemoveConfirmModal({ item, onRemove, onMoveToWishlist, onClose }) {
  if (!item) return null;
  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center px-4" onClick={onClose}>
      <div className="absolute inset-0 bg-black/40" />
      <div
        className="relative bg-white rounded-2xl shadow-2xl w-full max-w-sm p-5"
        style={{ animation: 'pop-in 0.25s cubic-bezier(0.175,0.885,0.32,1.275) forwards' }}
        onClick={e => e.stopPropagation()}
      >
        {/* Close */}
        <button onClick={onClose} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600">
          <X className="w-5 h-5" />
        </button>

        <h3 className="font-bold text-gray-800 text-base mb-4">Remove product from cart</h3>

        <div className="flex items-center gap-4 mb-5">
          <div className="w-20 h-20 rounded-xl overflow-hidden bg-gray-100 shrink-0 border border-gray-100">
            {item.image
              ? <img src={cldImg(item.image, 160)} alt={item.name} className="w-full h-full object-cover" />
              : <div className="w-full h-full flex items-center justify-center text-2xl">📦</div>}
          </div>
          <p className="text-sm text-gray-600 leading-snug">
            Are you sure you want to remove this product from cart.
          </p>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onRemove}
            className="flex-1 py-3 rounded-xl border border-red-200 text-red-500 font-bold text-sm hover:bg-red-50 transition-colors"
          >
            Remove
          </button>
          <button
            onClick={onMoveToWishlist}
            className="flex-1 py-3 rounded-xl bg-brand-yellow text-brand-dark font-bold text-sm hover:opacity-90 transition-opacity flex items-center justify-center gap-2"
          >
            <Heart className="w-4 h-4" /> Move to Wishlist
          </button>
        </div>
      </div>

      <style>{`
        @keyframes pop-in {
          0%   { transform: scale(0.85); opacity: 0; }
          100% { transform: scale(1);    opacity: 1; }
        }
      `}</style>
    </div>
  );
}
